import * as yup from "yup";
import {MESSAGES} from "./messages";

const projectFormSchema = yup.object().shape({
  name: yup.string()
    .max(64, MESSAGES.MAX_LENGTH)
    .required(MESSAGES.REQUIRED)
});

export default projectFormSchema;